import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getFieldsAsync = createAsync(() => {
  return async function getChargeExportFields(options) {
    const resp = await api.ChargeExportTemplates.getFields(options);
    this.setFields(resp.response);
    return resp;
  };
});
const getTemplatesAsync = createAsync(body => {
  return async function getChargeExportTemplates(options) {
    var _body$propertyId;
    const resp = await api.ChargeExportTemplates.getTemplates(body, options);
    this.setTemplates((_body$propertyId = body.propertyId) !== null && _body$propertyId !== void 0 ? _body$propertyId : '', resp.response);
    return resp;
  };
});
const saveTemplateAsync = createAsync(body => {
  return async function saveChargeExportTemplate(options) {
    return api.ChargeExportTemplates.saveTemplate(body, options);
  };
});
const setDefaultTemplateAsync = createAsync(body => {
  return async function setDefaultChargeExportTemplate(options) {
    return api.ChargeExportTemplates.setDefaultTemplate(body, options);
  };
});
const deleteTemplateAsync = createAsync(body => {
  return async function deleteChargeExportTemplate(options) {
    return api.ChargeExportTemplates.deleteTemplate(body, options);
  };
});

/**
 * The saved charge-export column mappings, cached per property.
 *
 * Keyed by property because the same account-level template can be the effective default for one
 * property and not another — `isEffectiveDefault` is resolved server-side against the property that
 * was asked for, so one flat list would answer that question wrongly for every other property.
 */
const ChargeExportTemplatesStore = types.model('ChargeExportTemplatesStore', {
  deleteTemplateAsync,
  getFieldsAsync,
  getTemplatesAsync,
  saveTemplateAsync,
  setDefaultTemplateAsync,
  fields: types.optional(types.frozen(), []),
  templatesByProperty: types.optional(types.map(types.frozen()), {})
}).actions(store => {
  return {
    setFields(fields) {
      try {
        store.fields = fields !== null && fields !== void 0 ? fields : [];
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setTemplates(propertyId, templates) {
      try {
        store.templatesByProperty.set(propertyId, templates !== null && templates !== void 0 ? templates : []);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  /** The templates already loaded for a property; empty until `getTemplatesAsync` has run for it. */
  templatesFor(propertyId) {
    var _store$templatesByPro;
    return (_store$templatesByPro = store.templatesByProperty.get(propertyId)) !== null && _store$templatesByPro !== void 0 ? _store$templatesByPro : [];
  },
  /** The template an export runs with when the user does not pick one. */
  effectiveDefaultFor(propertyId) {
    var _store$templatesByPro2;
    return ((_store$templatesByPro2 = store.templatesByProperty.get(propertyId)) !== null && _store$templatesByPro2 !== void 0 ? _store$templatesByPro2 : []).find(template => template.isEffectiveDefault);
  }
}));
export const chargeExportTemplates = types.optional(ChargeExportTemplatesStore, {});

// store.chargeExportTemplates.getTemplatesAsync.run({ propertyId })